import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";

export const COUNTRIES = [
  { code: "FR", flag: "🇫🇷", label: "France" },
  { code: "MA", flag: "🇲🇦", label: "Maroc" },
  { code: "ES", flag: "🇪🇸", label: "Espagne" },
  { code: "GB", flag: "🇬🇧", label: "Royaume-Uni" },
  { code: "DE", flag: "🇩🇪", label: "Allemagne" },
  { code: "IT", flag: "🇮🇹", label: "Italie" },
  { code: "BE", flag: "🇧🇪", label: "Belgique" },
  { code: "US", flag: "🇺🇸", label: "États-Unis" },
  { code: "INT", flag: "🌍", label: "International" },
];

export const flagFor = (code?: string | null) => {
  if (!code) return "🌍";
  const c = COUNTRIES.find((x) => x.code === code.toUpperCase());
  return c ? c.flag : "🌍";
};

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  onConfirm: (countryCode: string) => void;
  description?: string;
}

const CountryPickerDialog = ({ open, onOpenChange, onConfirm, description }: Props) => {
  const [code, setCode] = useState("FR");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <Globe className="h-5 w-5 text-primary" /> Pays cible
          </DialogTitle>
          <DialogDescription>
            {description || "Sélectionnez l'audience cible pour ces mots-clés. L'IA adaptera vocabulaire, devises et références."}
          </DialogDescription>
        </DialogHeader>
        <div className="py-3">
          <Select value={code} onValueChange={setCode}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              {COUNTRIES.map((c) => (
                <SelectItem key={c.code} value={c.code}>{c.flag} {c.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button onClick={() => { onConfirm(code); onOpenChange(false); }} className="bg-gradient-gold text-primary-foreground">
            Valider et ajouter
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CountryPickerDialog;